var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62467 2.25L10.7497 4.375M7.20801 12.1667H12.8747M1.54134 9.33333L0.833008 12.1667L3.66634 11.4583L11.8731 3.25158C12.1387 2.98592 12.2879 2.62565 12.2879 2.25C12.2879 1.87435 12.1387 1.51408 11.8731 1.24841L11.7513 1.12658C11.4856 0.860996 11.1253 0.7118 10.7497 0.7118C10.374 0.7118 10.0138 0.860996 9.74809 1.12658L1.54134 9.33333Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.180b5e6f4e29b60b210bc6f8f51f69b4.svg";
export { ForwardRef as ReactComponent };